// src/components/shared/LanguageSwitcher.js
// Sélecteur de langue FR/EN - NE PAS MODIFIER

import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import { useTheme } from '../../hooks/useTheme';

const LanguageSwitcher = ({ compact = false }) => {
  const { language, changeLanguage } = useLanguage();
  const { theme } = useTheme();

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      backgroundColor: theme.bgInput,
      borderRadius: '20px',
      padding: '4px',
      border: `1px solid ${theme.border}`,
    },
    button: {
      padding: compact ? '4px 10px' : '6px 14px',
      borderRadius: '16px',
      border: 'none',
      backgroundColor: 'transparent',
      color: theme.textSecondary,
      fontSize: compact ? '12px' : '13px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 200ms ease-in-out',
      minWidth: '40px',
      minHeight: compact ? 'auto' : '32px',
    },
    buttonActive: {
      backgroundColor: theme.gold,
      color: theme.mode === 'light' ? '#FFFFFF' : '#0A0E1A',
    },
  };

  return (
    <div style={styles.container}>
      <button
        style={{
          ...styles.button,
          ...(language === 'fr' ? styles.buttonActive : {}),
        }}
        onClick={() => changeLanguage('fr')}
      >
        FR
      </button>
      <button
        style={{
          ...styles.button,
          ...(language === 'en' ? styles.buttonActive : {}),
        }}
        onClick={() => changeLanguage('en')}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;